import { canAccessPage } from './accessControl';

const USER_SHOW_LINK_ROLES = new Set<string>([
    'moderator',
    'moderator-admin',
    'expert',
    'expert-admin',
    'expert-outstaff',
    'expert-admin-outstaff',
    'manager-admin'
]);

export function canOpenPlatformUserShow(role: string | undefined | null): boolean {
    if (!role) {
        return false;
    }

    if (!USER_SHOW_LINK_ROLES.has(role)) {
        return false;
    }

    return canAccessPage(role, 'users');
}

export function getPlatformUserShowUrl(userId: string): string {
    const baseUrl = window.location.href.split('#')[0];
    return `${baseUrl}#/users/${encodeURIComponent(userId.trim())}/show`;
}
